<h1 class="title-center">Custom SQL Queries</h1>
<br />

@if (addingSqlQuery && checkAccess(['LOSTalker.Admin']))
{
  <app-add-sql-query
    [integration]="integration()"
    [client]="client"
    [isInTab]="isInTab"
    (itemAdded)="sqlQueryAdded($event)"
    (cancel)="sqlQueryCancel()"></app-add-sql-query>
}
@else if (editingSqlQuery && selectedQuery && checkAccess(['LOSTalker.Admin']))
{
  <app-edit-sql-query
    [customSQLQueryId]="selectedQuery.customSQLQueryId"
    (itemUpdated)="sqlQueryUpdated($event)"
    (cancel)="sqlQueryCancel()"></app-edit-sql-query>
}
@else
{
  <button matButton="elevated" class="my-2" [disabled]="!checkAccess(['LOSTalker.Admin'])" (click)="goToAdd()">Add New Query</button>

  <app-lt-png-table [gridSettingsInput]="sqlQueryGridSettings()" (deleteClicked)="setDeletingSqlQuery($event)" (editClicked)="setEditingSqlQuery($event)"></app-lt-png-table>
}

<ng-template #deleteSqlQueryDialog>
  <h2 matDialogTitle>Confirm Deleting Sql Query</h2>
  <mat-dialog-content>
    <span>The Sql Query for {{selectedQuery.integrationSourceTypeId}} - {{selectedQuery.integrationName}} will be deleted.</span>
    <br/>
    <span>Query Name: {{selectedQuery.queryName}}</span>
    <br/>
    <span>Query Type: {{selectedQuery.queryTypeName}}</span>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton [disabled]="deletingSqlQuery" (click)="deleteSqlQuery()">Delete</button>
    <button matButton [disabled]="deletingSqlQuery" matDialogClose>Cancel</button>
  </mat-dialog-actions>
</ng-template>